<template>
  <div>
    <b-button
      style="padding: 0px!important;font-size:14px; height:34px !important; width: 130px!important;"
      :class="[is_free_plan ? 'btn_white btn-auto-create disable-style-auto-create' : 'btn_white btn-auto-create']"
      @click="action"
    >
      <span>シフト自動作成</span>
    </b-button>
  </div>
</template>

<style>
.btn-auto-create {
  width: 170x!important;
  height: 34px!important;
  color: #FB82B4!important;
  border: solid 1px #FB82B4!important;
}
.swal-cancel-button-auto-create {
  background-color: #FB82B4!important;
  color: white !important;
}
.disable-style-auto-create {
  opacity: 0.65;
}
</style>

<script>
export default {
  name: 'BtnAutoCreate',
  props: {
    year: {
      type: String,
      default: 0
    },
    month: {
      type: String,
      default: 0
    },
    officeId: {
      type: Number,
      required: true,
    },
    team_id: {
      type: Number,
      default: 0,
    },
    is_free_plan: {
        type: Boolean,
        default: false,
    },
    is_shift_application_finished: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      interval_check_auto_creation: null,
    }
  },
  methods: {
    // loadingの制御
    updateLoading(flg) {
      EventBus.$emit('updateLoading', flg);
    },
    updatePreparingFlg(flg) {
      this.$emit('updatePreparingFlg', flg);
    },
    action() {
      if (this.is_free_plan) {
          const url = route('lodgments.plan-edit');
          const message = `機能制限無料プランでのご利用のため、過去のシフトの参照ができません。過去のシフトを参照いただく場合は、<a href='${url}'>スタンダードプランへの変更</a>をお願いします。`;
          this.$swal({
              icon: 'info',
              html: message,
          });
          return;
      }
      if (!this.is_shift_application_finished) {
          const message = `シフトに反映されていない申請があります。シフト自動作成する前に、希望申請状況画面で承認作業を行い、「申請をシフト表へ反映」ボタンをクリックしてください。`;

          this.$swal({
              icon: 'info',
              html: message,
              showCancelButton: true,
              confirmButtonText: '希望申請状況',
              cancelButtonText: 'シフト自動作成',
              customClass: {
                  cancelButton: 'swal-cancel-button-auto-create',
              }
          }).then((result) => {
              if (result.value) {
                  this.updateLoading(true);
                  this.redirectToApplicationStatus();
              } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                this.updateLoading(true);  
                this.redirectToAutoCreate();
              }
          });
          return;
      }
      this.updateLoading(true);
      this.redirectToAutoCreate();
    },
    // 自動作成フローに遷移する
    redirectToAutoCreate() {
      this.$inertia.get(route('offices.edit', this.officeId), {
        is_autocreate: true,
        year : this.year,
        month : this.month,
        office_id: this.officeId,
        team_id: this.team_id,
      });
    },
    // 希望申請状況画面に遷移する
    redirectToApplicationStatus() {
      this.$inertia.get(route('shifts.application-status', {
        year: this.year,
        month: this.month,
        office: this.officeId
      }));
    },
  },
};
</script>
